module.exports = __webpack_public_path__ + "static/media/jupyter.64643e1b.png";